// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  p1: __t.identity().name("p_1"),
  p2: __t.identity().name("p_2"),
  p1Name: __t.string().name("p_1_name"),
  p2Name: __t.string().name("p_2_name"),
  p1Rating: __t.i32().name("p_1_rating"),
  p2Rating: __t.i32().name("p_2_rating"),
  stake: __t.u32(),
  balanceKind: __t.string().name("balance_kind"),
  economyModel: __t.string().name("economy_model"),
  mode: __t.string(),
  room: __t.string(),
  phase: __t.string(),
  status: __t.string(),
  currentRound: __t.u32().name("current_round"),
  p1Score: __t.u32().name("p_1_score"),
  p2Score: __t.u32().name("p_2_score"),
  p1Energy: __t.i32().name("p_1_energy"),
  p2Energy: __t.i32().name("p_2_energy"),
  p1BoostEnabled: __t.bool().name("p_1_boost_enabled"),
  p2BoostEnabled: __t.bool().name("p_2_boost_enabled"),
  p1SeasonPointsAwarded: __t.u32().name("p_1_season_points_awarded"),
  p2SeasonPointsAwarded: __t.u32().name("p_2_season_points_awarded"),
  p1CommitHash: __t.option(__t.string()).name("p_1_commit_hash"),
  p2CommitHash: __t.option(__t.string()).name("p_2_commit_hash"),
  p1RevealMove: __t.option(__t.u32()).name("p_1_reveal_move"),
  p2RevealMove: __t.option(__t.u32()).name("p_2_reveal_move"),
  p1RevealSalt: __t.option(__t.string()).name("p_1_reveal_salt"),
  p2RevealSalt: __t.option(__t.string()).name("p_2_reveal_salt"),
  winner: __t.option(__t.identity()),
  replayHash: __t.option(__t.string()).name("replay_hash"),
  createdAtMicros: __t.u64().name("created_at_micros"),
  updatedAtMicros: __t.u64().name("updated_at_micros"),
  roundStartedAtMicros: __t.u64().name("round_started_at_micros"),
  nextRoundReadyAtMicros: __t.option(__t.u64()).name("next_round_ready_at_micros"),
});
